import { install as installResizeObserver } from 'resize-observer';

export default {
  setup: function() {
    if (typeof window.ResizeObserver !== 'undefined') return;

    installResizeObserver();
  },
};
